import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const ForumGroupBasicInfoComponent = ({
    selectedForumGroup, handleInnerFormChange,communities
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Name"
                            labelField="Name"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                            type="text"
                            value={selectedForumGroup?.Name}
                        />

                        
                            <InputContainer
                                label="Display Order"
                                name="DisplayOrder"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'DisplayOrder'
                                    );
                                }}
                                type="number"
                                value={selectedForumGroup?.DisplayOrder}
                            />

                             <InputContainer
                                label="Community"
                                labelField="Name"
                                list={communities}
                                onValueChange={(event: any) => {
                                handleInnerFormChange(
                                event.target.value,
                                'CommunityId'
                                )
                                }}
                                optionName='Choose Community'
                                type="select"
                                value={selectedForumGroup?.CommunityId}
                                valueField="Id"
                                                    />

                       
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}

export default ForumGroupBasicInfoComponent;
